import { useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  deleteUser,
  EmailAuthProvider,
  onAuthStateChanged,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  signOut,
  type User,
} from "firebase/auth";
import { auth } from "../lib/firebase";

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setInitializing(false);
    });
    return unsub;
  }, []);

  return {
    user,
    initializing,
    login: (email: string, password: string) => signInWithEmailAndPassword(auth, email, password),
    register: (email: string, password: string) => createUserWithEmailAndPassword(auth, email, password),
    logout: () => signOut(auth),
    deleteAccount: async (password: string) => {
      const current = auth.currentUser;
      if (!current || !current.email) throw new Error("Nicht angemeldet.");
      const credential = EmailAuthProvider.credential(current.email, password);
      await reauthenticateWithCredential(current, credential);
      await deleteUser(current);
    },
  };
}
